import * as React from 'react';
import { logTrace } from '../../../asyncHelpers/loggerService';

interface Props {
    fallback: JSX.Element;
    children?: React.ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        logTrace({
            message: JSON.stringify(error) + ' ' + info.componentStack,
        });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <>{this.props.fallback}</>;
        }

        return <>{this.props.children}</>;
    }
}
